{
  "2v2doubles": [["2015-06", 46], ["2015-05", 2225]],
  "350cup": [["2016-01", 123], ["2015-12", 32786]],
  "aaaubers": [["2016-08", 183], ["2016-07", 13477]],
  "abilityunity": [["2016-05", 32], ["2016-04", 33443]],
  "averagemons": [["2015-07", 49], ["2015-06", 10483]],
  "battlecup1v1": ["2015-06", 11156],
  "battleofhoenn": ["2015-01", 23923],
  "battlespotspecial10": [["2015-07", 117], ["2015-06", 500]],
  "battlespotspecial11": [["2015-09", 226], ["2015-07", 2097]],
  "battlespotspecial12": [["2015-11", 128], ["2015-10", 441]],
  "battlespotspecial13": [["2016-01", 4], ["2015-11", 1020]],
  "battlespotspecial17": [["2016-10", 4], ["2016-07", 2948]],
  "battlespotspecial7": [["2015-01", 6], ["2014-12", 1058]],
  "battlespotspecial8": [["2015-02", 6], ["2015-01", 8]],
  "bhdoubles": [["2016-10", 570], ["2016-09", 21177]],
  "capcrucibelleplaytest": [["2016-02", 73], ["2016-01", 2036]],
  "capnaviathanplaytest": [["2015-07", 97], ["2015-06", 1491]],
  "capplasmantaplaytest": ["2014-11", 7],
  "challengecup": [["2015-06", 4951], ["2015-05", 11331]],
  "challengecup1v1": [["2016-12", 334], ["2016-11", 129504]],
  "challengecup1vs1": [["2015-05", 2927], ["2015-03", 8136]],
  "classichackmons": [["2015-03", 230], ["2015-02", 26986]],
  "custompower": [["2016-07", 26], ["2016-06", 12146]],
  "doublesoususpecttest": ["2016-09", 92627],
  "doublesubers": ["2016-11", 27978],
  "dragoncup": ["2015-02", 135],
  "enchanteditems": [["2016-08", 739], ["2016-07", 39537]],
  "enterthedragontype": ["2015-03", 5166],
  "extremetiershift": [["2016-06", 63], ["2016-05", 52861]],
  "festivefeud": [["2015-12", 3200], ["2015-11", 4470]],
  "finaldestination": ["2015-04", 1545],
  "flashclash": [["2016-05", 105], ["2016-04", 20215]],
  "followtheleader": [["2016-09", 16], ["2016-08", 23399]],
  "fu": [["2015-02", 262], ["2015-01", 33291]],
  "gen11v1": [["2023-05", 4], ["2018-03", 1695]],
  "gen1challengecup": [["2018-08", 122], ["2018-07", 2047]],
  "gen1customgame": ["2021-05", 1],
  "gen1nintendocup1997": ["2022-09", 2155],
  "gen1nobig4ou": [["2019-07", 110], ["2017-01", 490]],
  "gen1nu": ["2022-02", 1645],
  "gen1ou": ["2023-10", 26202],
  "gen1oubeta": ["2014-12", 488],
  "gen1oumew": [["2017-08", 1], ["2017-07", 780]],
  "gen1ounodefenseboosting": ["2020-02", 79],
  "gen1ounodefensecurlhardenorreflect": ["2020-02", 11],
  "gen1ounotauros": [["2019-02", 1], ["2019-01", 157]],
  "gen1pu": [["2023-10", 23], ["2023-09", 3960]],
  "gen1randombattle": ["2017-02", 79370],
  "gen1stabmons": ["2018-01", 331],
  "gen1stadium": ["2018-03", 3],
  "gen1stadiumou": [["2023-08", 5], ["2023-07", 406]],
  "gen1tradebacksou": ["2023-04", 907],
  "gen1ubers": [["2023-07", 8], ["2023-06", 2888]],
  "gen1uu": [["2023-01", 19], ["2022-12", 1851]],
  "gen21v1": [["2020-01", 1], ["2019-12", 111]],
  "gen2inverseou": ["2019-03", 34],
  "gen2mediocremons": [["2018-09", 1], ["2018-08", 126]],
  "gen2nc2000crystalmoves": [["2021-11", 58], ["2021-10", 4605]],
  "gen2nu": ["2023-10", 1768],
  "gen2ou": ["2023-10", 10270],
  "gen2oubeta": ["2014-12", 181],
  "gen2oublitz": [["2019-09", 2], ["2019-08", 91]],
  "gen2ouhoohcelebi": [["2018-03", 2], ["2018-02", 559]],
  "gen2ouitemclause": ["2019-02", 32],
  "gen2ounosnorlax": [["2017-05", 2], ["2017-04", 244]],
  "gen2pu": [["2020-11", 1], ["2020-10", 1276]],
  "gen2stabmons": ["2017-08", 231],
  "gen2ubers": [["2023-08", 7], ["2023-07", 1240]],
  "gen2uu": [["2023-02", 2], ["2023-01", 2025]],
  "gen2uubl": [["2022-11", 1], ["2022-10", 1494]],
  "gen2uumuk": ["2023-10", 663],
  "gen31v1": [["2022-08", 159], ["2022-07", 20497]],
  "gen3adv200": [["2019-01", 42], ["2017-02", 144]],
  "gen3bl": [["2017-10", 4], ["2017-09", 81]],
  "gen3customgame": ["2021-05", 4],
  "gen3doublesou": [["2022-12", 7], ["2022-11", 3666]],
  "gen3hoenngaiden": [["2023-10", 71], ["2023-09", 303]],
  "gen3lc": [["2023-09", 4], ["2023-08", 2840]],
  "gen3nu": [["2021-07", 9], ["2021-06", 2317]],
  "gen3ou": ["2023-10", 283861],
  "gen3oubeta": [["2015-03", 467], ["2015-01", 1791]],
  "gen3oulatias": ["2019-07", 129],
  "gen3ounospikes": ["2019-03", 84],
  "gen3ounotyranitar": [["2018-04", 1], ["2018-03", 121]],
  "gen3stabmons": ["2018-07", 237],
  "gen3tiershift": [["2018-10", 3], ["2018-09", 62]],
  "gen3ubers": [["2023-09", 3], ["2023-08", 7950]],
  "gen3ubersbeta": [["2015-03", 4], ["2014-12", 25]],
  "gen3uu": [["2023-03", 24], ["2023-02", 1927]],
  "gen3uubl": [["2020-05", 4], ["2020-04", 387]],
  "gen41v1": [["2020-03", 1], ["2020-02", 745]],
  "gen4anythinggoes": [["2022-06", 91], ["2022-05", 5664]],
  "gen4balancedhackmons": ["2017-12", 90],
  "gen4customgame": ["2021-05", 3],
  "gen4doublesou": [["2023-09", 123], ["2023-08", 620]],
  "gen4lc": ["2022-09", 2544],
  "gen4monotype": ["2020-12", 1903],
  "gen4nu": [["2023-03", 12], ["2023-02", 1541]],
  "gen4ou": ["2023-10", 77580],
  "gen4oulatimence": ["2017-05", 148],
  "gen4outeampreview": [["2018-07", 2], ["2018-06", 164]],
  "gen4pu": [["2018-12", 62], ["2018-04", 65]],
  "gen4ubers": [["2023-10", 84], ["2023-09", 26760]],
  "gen4uu": [["2023-04", 22], ["2023-03", 5071]],
  "gen4zu": [["2023-02", 34], ["2023-01", 2330]],
  "gen51v1": ["2023-09", 3915],
  "gen52v2doubles": ["2020-09", 1009],
  "gen5anythinggoes": [["2017-01", 64], ["2016-12", 8640]],
  "gen5balancedhackmons": ["2019-05", 156],
  "gen5customgame": ["2018-03", 3],
  "gen5doublescustomgame": ["2018-03", 1],
  "gen5doublesou": [["2022-01", 15], ["2021-12", 1582]],
  "gen5gbudoubles": [["2018-01", 1], ["2015-05", 2]],
  "gen5gbusingles": [["2015-06", 9], ["2015-04", 4375]],
  "gen5lc": [["2022-02", 6], ["2022-01", 370]],
  "gen5monotype": ["2018-10", 525],
  "gen5nu": [["2022-05", 9], ["2022-04", 1183]],
  "gen5ou": ["2023-10", 59781],
  "gen5oublind": ["2017-06", 171],
  "gen5pu": [["2022-04", 12], ["2022-03", 1751]],
  "gen5ru": [["2023-03", 10], ["2023-02", 1730]],
  "gen5smogondoubles": [["2015-04", 1], ["2015-03", 25]],
  "gen5ubers": ["2023-10", 12966],
  "gen5uu": ["2023-04", 4862],
  "gen5vgc2013": ["2023-05", 3],
  "gen5zu": [["2023-04", 2], ["2023-03", 1631]],
  "gen61v1": [["2022-01", 14], ["2016-11", 243201]],
  "gen6almostanyability": [["2021-05", 131], ["2016-10", 7600]],
  "gen6anythinggoes": [["2021-06", 5], ["2017-07", 13973]],
  "gen6balancedhackmons": [["2019-07", 2], ["2016-11", 90551]],
  "gen6battlefactory": [["2018-12", 789], ["2018-02", 13353]],
  "gen6battlespotdoubles": [["2018-01", 1], ["2014-12", 112633]],
  "gen6battlespotsingles": [["2021-06", 3], ["2016-11", 112405]],
  "gen6battlespottriples": [["2017-12", 7], ["2016-12", 3038]],
  "gen6cap": [["2021-05", 4], ["2016-11", 10305]],
  "gen6customgame": ["2021-05", 8],
  "gen6doublesou": [["2023-10", 2652], ["2017-01", 24352]],
  "gen6doublesuu": [["2017-07", 3], ["2016-11", 14863]],
  "gen6lc": [["2023-02", 13], ["2016-11", 68009]],
  "gen6mixandmega": [["2018-09", 5], ["2016-11", 46660]],
  "gen6monotype": [["2020-11", 1], ["2016-11", 232353]],
  "gen6nu": [["2020-01", 2], ["2016-12", 13243]],
  "gen6ou": ["2023-10", 67178],
  "gen6ounoteampreview": [["2018-01", 8], ["2017-12", 520]],
  "gen6pu": [["2022-05", 10], ["2016-11", 82966]],
  "gen6purehackmons": ["2023-10", 26391],
  "gen6randombattle": ["2017-02", 20405],
  "gen6ru": [["2023-04", 1839], ["2016-11", 71167]],
  "gen6triplescustomgame": ["2018-01", 1],
  "gen6ubers": [["2023-05", 1], ["2022-11", 14204]],
  "gen6uu": [["2023-06", 17], ["2017-01", 27784]],
  "gen6vgc2016": [["2021-05", 1], ["2016-11", 160180]],
  "gen71v1": [["2021-05", 1], ["2020-11", 12939]],
  "gen71v1suspecttest": ["2018-02", 10856],
  "gen72017noholdsbarred": ["2017-08", 26487],
  "gen72v2doubles": [["2018-11", 30], ["2018-10", 14847]],
  "gen7350cup": [["2019-11", 80], ["2019-10", 20711]],
  "gen7almostanyability": [["2019-11", 4116], ["2019-03", 9462]],
  "gen7almostanyabilitysuspecttest": [["2018-01", 707], ["2017-12", 5835]],
  "gen7alolafriendly": [["2017-02", 6], ["2017-01", 31637]],
  "gen7alphabetcup": [["2018-02", 468], ["2018-01", 22794]],
  "gen7anythinggoes": ["2022-11", 84902],
  "gen7anythinggoesbeta": ["2016-11", 53352],
  "gen7averagemons": [["2018-12", 35], ["2018-11", 18468]],
  "gen7balancedhackmons": [["2022-12", 622], ["2022-03", 16929]],
  "gen7balancedhackmonssuspecttest": [["2018-08", 8894], ["2018-07", 12031]],
  "gen7battlefactory": ["2018-12", 96762],
  "gen7battleofalola": ["2016-12", 35226],
  "gen7battlespotdoubles": [["2019-11", 3788], ["2018-06", 10438]],
  "gen7battlespotsingles": ["2019-11", 42585],
  "gen7battlespotspecial1": [["2017-01", 21], ["2016-12", 301]],
  "gen7battlespotspecial10": [["2018-07", 1], ["2018-05", 462]],
  "gen7battlespotspecial11": [["2018-08", 237], ["2018-07", 721]],
  "gen7battlespotspecial12": [["2018-11", 1], ["2018-09", 255]],
  "gen7battlespotspecial13": [["2018-12", 5], ["2018-11", 629]],
  "gen7battlespotspecial14": [["2019-03", 4], ["2019-01", 25]],
  "gen7battlespotspecial15": [["2019-06", 12], ["2019-04", 3064]],
  "gen7battlespotspecial16": [["2019-08", 7], ["2019-06", 2606]],
  "gen7battlespotspecial17": [["2019-11", 1], ["2019-09", 2326]],
  "gen7battlespotspecial2": [["2017-03", 616], ["2017-02", 1256]],
  "gen7battlespotspecial3": [["2017-05", 24], ["2017-03", 144]],
  "gen7battlespotspecial4": [["2017-07", 10], ["2017-05", 750]],
  "gen7battlespotspecial5": [["2017-09", 250], ["2017-07", 1541]],
  "gen7battlespotspecial6": [["2017-11", 63], ["2017-09", 942]],
  "gen7battlespotspecial7": [["2018-01", 22], ["2017-12", 47]],
  "gen7battlespotspecial8": [["2018-03", 79], ["2018-01", 1448]],
  "gen7battlespotspecial9": [["2018-04", 4], ["2018-03", 371]],
  "gen7benjaminbutterfree": ["2018-09", 16],
  "gen7bssfactory": ["2018-12", 18935],
  "gen7camomons": [["2019-11", 1109], ["2017-04", 59625]],
  "gen7cap": [["2020-01", 84], ["2019-06", 10904]],
  "gen7caplc": ["2018-03", 1],
  "gen7challengecup": ["2016-11", 26024],
  "gen7challengecup1v1": ["2018-12", 98097],
  "gen7challengecup2v2": ["2018-03", 12],
  "gen7challengecupbeta": ["2016-11", 10628],
  "gen7chimera": [["2019-04", 40], ["2019-03", 27416]],
  "gen7crossevolution": [["2019-09", 73], ["2019-08", 18888]],
  "gen7customgame": [["2021-05", 5], ["2018-03", 43]],
  "gen7doublesanythinggoesbeta": ["2016-11", 6888],
  "gen7doublescustomgame": [["2018-04", 1], ["2018-03", 30]],
  "gen7doubleshackmonscup": [["2018-04", 1], ["2018-03", 49]],
  "gen7doublesou": ["2023-10", 13536],
  "gen7doublesoubeta": ["2016-11", 38],
  "gen7doublesoususpecttest": ["2018-05", 54625],
  "gen7doublesubers": ["2019-11", 17263],
  "gen7doublesuu": [["2019-11", 9739], ["2019-10", 16010]],
  "gen7dragoncup": [["2018-01", 1295], ["2017-11", 12619]],
  "gen7dualwielding": [["2017-12", 93], ["2017-11", 18529]],
  "gen7followtheleader": [["2019-08", 39], ["2019-07", 31354]],
  "gen7fortemons": [["2018-12", 71], ["2018-11", 54918]],
  "gen7fullpotential": [["2017-12", 338], ["2017-11", 25858]],
  "gen7godlygift": [["2019-05", 238], ["2019-04", 65358]],
  "gen7godsandfollowers": [["2018-11", 61], ["2018-10", 41524]],
  "gen7hackmonscup": ["2018-12", 48123],
  "gen7hiddentype": [["2019-03", 3], ["2019-02", 8655]],
  "gen7inheritance": [["2019-11", 168], ["2019-10", 27376]],
  "gen7inverse": [["2018-06", 89], ["2018-05", 28228]],
  "gen7johtoxalola": ["2017-12", 10867],
  "gen7kantoxalolaregionalrumble": ["2017-03", 42001],
  "gen7lastwill": [["2017-06", 83], ["2017-05", 23009]],
  "gen7lc": [["2022-04", 10], ["2019-11", 26585]],
  "gen7lcsuspecttest": ["2018-03", 46340],
  "gen7letsgo1v1": ["2019-01", 2298],
  "gen7letsgocup": [["2018-08", 7289], ["2018-07", 59877]],
  "gen7letsgodoublesnorestrictions": [["2019-02", 15], ["2018-12", 166]],
  "gen7letsgodoublesou": [["2019-11", 26], ["2019-01", 490]],
  "gen7letsgohackmons": [["2019-01", 3], ["2018-12", 755]],
  "gen7letsgoou": [["2023-09", 2], ["2019-04", 10883]],
  "gen7letsgosinglesnorestrictions": [["2019-02", 374], ["2019-01", 1029]],
  "gen7letsgouu": [["2022-09", 11], ["2022-08", 396]],
  "gen7linked": [["2019-09", 522], ["2019-08", 64187]],
  "gen7mediocremons": [["2018-01", 89], ["2017-12", 12377]],
  "gen7megamelee": ["2017-09", 22039],
  "gen7megamons": [["2019-10", 59], ["2019-09", 24429]],
  "gen7mergemons": [["2019-10", 10], ["2019-09", 26739]],
  "gen7metagamiate": [["2018-08", 371], ["2018-07", 26395]],
  "gen7metronomebattle": ["2018-04", 112062],
  "gen7middlecup": [["2018-03", 6], ["2018-02", 9750]],
  "gen7mixandmega": ["2023-03", 14775],
  "gen7mixandmegalc": [["2019-05", 41], ["2019-04", 13503]],
  "gen7mixandmegasuspecttest": ["2018-04", 20344],
  "gen7monotype": [["2023-06", 17], ["2020-10", 35548]],
  "gen7monotypesuspecttest": ["2017-12", 162577],
  "gen7natureswap": [["2019-08", 77], ["2019-07", 18645]],
  "gen7nfe": [["2019-07", 90], ["2019-06", 19251]],
  "gen7nu": [["2023-06", 10], ["2019-11", 43826]],
  "gen7nualpha": ["2017-06", 44168],
  "gen7nubeta": ["2017-08", 33407],
  "gen7nususpecttest": [["2018-07", 5073], ["2018-06", 37722]],
  "gen7ou": ["2023-10", 159606],
  "gen7oubeta": ["2016-11", 1441],
  "gen7oublitz": ["2019-11", 91483],
  "gen7ouprebank": ["2016-11", 3638],
  "gen7oususpecttest": ["2017-09", 1026428],
  "gen7partnersincrime": [["2019-10", 35], ["2018-09", 48860]],
  "gen7petmodcleanslatemicro": [["2020-03", 2], ["2020-01", 191]],
  "gen7pokbilities": [["2017-02", 65], ["2017-01", 40982]],
  "gen7pokebankag": ["2016-11", 1434],
  "gen7pokebankanythinggoes": ["2017-01", 532909],
  "gen7pokebankanythinggoesbeta": ["2016-11", 8],
  "gen7pokebankdoublesag": ["2016-11", 109],
  "gen7pokebankdoublesou": ["2017-01", 234237],
  "gen7pokebankdoublesoubeta": ["2016-11", 2],
  "gen7pokebankdoublesubers": ["2017-01", 34528],
  "gen7pokebanklc": ["2017-01", 54470],
  "gen7pokebankou": ["2017-01", 1141698],
  "gen7pokebankoubeta": ["2016-11", 16],
  "gen7pokebankoususpecttest": ["2017-01", 344597],
  "gen7pokebankubers": ["2017-01", 253817],
  "gen7pokebankuualpha": ["2016-12", 98346],
  "gen7pokebilities": [["2019-03", 78], ["2019-02", 54082]],
  "gen7prebankou": ["2017-01", 836064],
  "gen7pu": [["2022-11", 44], ["2019-11", 57390]],
  "gen7pualpha": ["2017-08", 14072],
  "gen7pubeta": ["2017-09", 25158],
  "gen7purehackmons": [["2023-10", 117], ["2023-09", 36351]],
  "gen7pususpecttest": ["2018-05", 29442],
  "gen7randombattle": ["2017-02", 4304257],
  "gen7randomdoublesbattle": ["2017-02", 369322],
  "gen7reversed": [["2018-08", 315], ["2018-07", 17491]],
  "gen7ru": [["2022-06", 19], ["2019-12", 10570]],
  "gen7rualpha": ["2017-03", 41092],
  "gen7rubeta": ["2017-06", 29301],
  "gen7rususpecttest": [["2018-08", 8930], ["2018-07", 48083]],
  "gen7scalemons": [["2018-07", 83], ["2018-06", 30074]],
  "gen7sharedpower": [["2018-03", 518], ["2018-02", 209191]],
  "gen7simplesymphony": [["2019-02", 19], ["2019-01", 15504]],
  "gen7sketchmons": [["2019-02", 52], ["2019-01", 33944]],
  "gen7sketchmonssuspecttest": [["2017-11", 96], ["2017-01", 1721]],
  "gen7stabmons": [["2021-06", 3], ["2018-02", 10957]],
  "gen7stabmonssuspecttest": [["2018-05", 77], ["2018-04", 3857]],
  "gen7suicidecup": [["2018-07", 89], ["2018-06", 29454]],
  "gen7tiershift": [["2019-12", 214], ["2019-11", 42284]],
  "gen7tinytourney": ["2017-06", 36500],
  "gen7trademarked": [["2019-06", 223], ["2019-05", 58964]],
  "gen7ubers": [["2023-01", 762], ["2022-12", 42469]],
  "gen7uberssuspecttest": ["2018-07", 76507],
  "gen7ultimatez": [["2019-06", 111], ["2019-05", 24282]],
  "gen7ultrafinal": [["2019-11", 1343], ["2019-09", 8928]],
  "gen7ultrakalosclassic": [["2018-05", 3], ["2018-04", 7677]],
  "gen7ultranoholdsbarred": [["2018-07", 31], ["2018-05", 8639]],
  "gen7ultrasinnohclassic": [["2018-03", 94], ["2018-02", 23083]],
  "gen7ultraspookycup": [["2018-11", 12], ["2018-10", 27522]],
  "gen7uu": [["2023-07", 16], ["2020-10", 12027]],
  "gen7uubeta": [["2017-02", 1126], ["2017-01", 173786]],
  "gen7uususpecttest": ["2018-06", 109713],
  "gen7vgc2017": [["2021-06", 2], ["2017-12", 22683]],
  "gen7vgc2017beta": ["2016-11", 8145],
  "gen7vgc2018": [["2019-11", 582], ["2018-11", 16190]],
  "gen7vgc2019moonseries": [["2019-04", 1945], ["2019-03", 148609]],
  "gen7vgc2019sunseries": ["2018-12", 114025],
  "gen7vgc2019ultraseries": [["2020-02", 52], ["2019-11", 119062]],
  "gen7weaknesscup": ["2017-07", 31581],
  "gen7zu": [["2020-02", 7], ["2019-11", 15376]],
  "gen81v1": ["2022-11", 138736],
  "gen82v2doubles": [["2022-11", 4128], ["2022-10", 7480]],
  "gen8350cup": [["2021-11", 44], ["2021-10", 15703]],
  "gen8aaadoubles": [["2021-12", 57], ["2021-11", 14145]],
  "gen8almostanyability": ["2022-11", 20973],
  "gen8alphabetcup": [["2021-09", 85], ["2021-08", 28884]],
  "gen8alternatium": [["2022-02", 2], ["2022-01", 3]],
  "gen8anythinggoes": [["2023-05", 1], ["2023-02", 87967]],
  "gen8anythinggoesobtainable": ["2021-05", 1],
  "gen8anythinggoeswitheternamax": ["2021-04", 3420],
  "gen8armorbeginnings": ["2020-07", 9010],
  "gen8balancedhackmons": ["2022-11", 13964],
  "gen8balancedhackmonsbeta": ["2019-11", 7345],
  "gen8battleoflegends": ["2020-10", 55006],
  "gen8battlestadiumdoubles": ["2020-10", 209968],
  "gen8battlestadiumdoublesseries13": [["2022-11", 1254], ["2022-10", 105417]],
  "gen8battlestadiumsingles": [["2023-01", 8], ["2022-11", 15082]],
  "gen8bdsp3v3singles": [["2022-03", 618], ["2022-01", 5910]],
  "gen8bdspbalancedhackmons": [["2022-01", 74], ["2021-12", 10236]],
  "gen8bdspbattlefestivaldoubles": [["2022-08", 65], ["2022-01", 48831]],
  "gen8bdspdoublesou": [["2022-12", 18], ["2022-03", 12348]],
  "gen8bdsplc": [["2022-08", 3], ["2022-01", 4142]],
  "gen8bdspmonotype": [["2022-08", 51], ["2022-01", 16705]],
  "gen8bdspnu": [["2022-08", 8], ["2022-03", 20363]],
  "gen8bdspou": [["2023-07", 6], ["2022-11", 18931]],
  "gen8bdsppu": [["2022-08", 32], ["2022-05", 4286]],
  "gen8bdspru": [["2022-08", 17], ["2022-02", 24002]],
  "gen8bdspubers": [["2022-08", 128], ["2021-12", 19309]],
  "gen8bdspuu": [["2022-08", 115], ["2022-02", 24150]],
  "gen8bonustype": [["2021-07", 275], ["2021-06", 42907]],
  "gen8brokenrecord": [["2022-08", 51], ["2022-07", 14071]],
  "gen8camomons": [["2022-02", 107], ["2022-01", 15902]],
  "gen8cap": [["2022-12", 90], ["2022-10", 20461]],
  "gen8cap1v1": [["2021-09", 213], ["2020-05", 4061]],
  "gen8categoryswap": [["2022-09", 23], ["2022-08", 19456]],
  "gen8championleague": [["2022-10", 185], ["2022-09", 8923]],
  "gen8chimera1v1": [["2022-09", 5319], ["2021-06", 17240]],
  "gen8crossevolution": [["2022-04", 141], ["2022-03", 22456]],
  "gen8doublescustomgame": ["2021-05", 9],
  "gen8doublesou": ["2023-10", 11130],
  "gen8doublesoubeta": ["2019-11", 19726],
  "gen8doublesoudynamaxlevel0": ["2020-07", 17667],
  "gen8doublesubers": [["2022-12", 8080], ["2022-11", 46671]],
  "gen8doublesuu": [["2022-12", 495], ["2022-11", 13374]],
  "gen8dragonkingcup": ["2020-12", 22379],
  "gen8extremespeedsinglebattles": ["2020-03", 24701],
  "gen8fairandsquare": [["2021-07", 11], ["2021-06", 4611]],
  "gen8firstblood": [["2021-08", 5], ["2021-07", 32449]],
  "gen8flipped": [["2022-05", 91], ["2022-04", 15449]],
  "gen8fu": ["2022-04", 293],
  "gen8fusionevolutionuu": [["2021-10", 1], ["2021-07", 7]],
  "gen8galarbeginnings": ["2019-12", 46135],
  "gen8galarnewcomers": [["2020-03", 169], ["2020-01", 25516]],
  "gen8godlygift": [["2022-11", 1511], ["2022-07", 10857]],
  "gen8gymchallenge": ["2021-11", 8733],
  "gen8ichoosechu": [["2022-09", 273], ["2022-08", 8712]],
  "gen8inheritance": [["2022-08", 122], ["2022-07", 22004]],
  "gen8inverse": [["2022-07", 26], ["2022-06", 8831]],
  "gen8jumpmagikarp": ["2022-07", 29426],
  "gen8lc": [["2023-03", 2], ["2022-11", 28832]],
  "gen8lcsuspecttest": ["2020-08", 315],
  "gen8linked": [["2022-03", 38], ["2022-02", 37126]],
  "gen8maxberries": [["2021-04", 4], ["2021-03", 25983]],
  "gen8megamax": [["2020-10", 10], ["2020-07", 660]],
  "gen8megasforall": [["2021-04", 3364], ["2021-03", 9554]],
  "gen8metronomebattle": ["2022-11", 39935],
  "gen8mixandmega": [["2022-11", 5763], ["2022-10", 11462]],
  "gen8monotype": [["2023-03", 112], ["2022-12", 15099]],
  "gen8monotypedynamax": ["2021-04", 1513],
  "gen8multibility": [["2021-11", 358], ["2021-10", 86367]],
  "gen8mythicalmelee": ["2021-09", 4878],
  "gen8natdexagwitheternamax": ["2021-04", 2210],
  "gen8natdexanythinggoes": ["2019-11", 12470],
  "gen8nationaldex": ["2023-10", 14800],
  "gen8nationaldexag": ["2022-11", 403232],
  "gen8nationaldexbeta": ["2019-12", 110443],
  "gen8nationaldexbh": [["2022-12", 231], ["2020-11", 13030]],
  "gen8nationaldexmonotype": ["2022-11", 62290],
  "gen8nationaldexnostall": ["2021-04", 2394],
  "gen8nationaldexuu": [["2022-12", 487], ["2022-11", 21176]],
  "gen8nationaldexuunostall": ["2021-04", 32],
  "gen8natureswap": [["2021-03", 189], ["2021-02", 46352]],
  "gen8ndmonotypenotoxapex": ["2021-04", 83],
  "gen8nfe": [["2022-11", 134], ["2021-05", 3261]],
  "gen8nu": [["2023-03", 4], ["2022-11", 23264]],
  "gen8nususpecttest": ["2021-04", 58],
  "gen8ou": ["2023-10", 71858],
  "gen8oubeta": ["2019-11", 298355],
  "gen8oublitz": ["2022-11", 12248],
  "gen8oususpecttest": ["2021-04", 6409],
  "gen8pacifistmons": [["2020-05", 6], ["2020-04", 4803]],
  "gen8partnersincrime": [["2022-10", 5], ["2022-09", 38210]],
  "gen8pokebilities": [["2022-02", 153], ["2022-01", 20921]],
  "gen8pokebilitiesaaa": [["2022-06", 1094], ["2022-05", 77591]],
  "gen8pu": [["2023-03", 4], ["2022-11", 36640]],
  "gen8puindeedeefnoteampreview": ["2021-04", 582],
  "gen8purehackmons": [["2022-12", 71], ["2022-11", 67000]],
  "gen8reevolution": [["2022-09", 318], ["2022-08", 20695]],
  "gen8revelationmons": [["2022-11", 254], ["2022-10", 32101]],
  "gen8ru": [["2023-03", 2], ["2022-11", 32191]],
  "gen8rudynamax": ["2021-04", 889],
  "gen8samedoublebeat": ["2021-08", 1513],
  "gen8scalemons": [["2020-12", 11], ["2020-03", 19031]],
  "gen8sharedpower": [["2022-04", 664], ["2022-03", 60729]],
  "gen8singlebattlecup": [["2022-07", 359], ["2022-06", 5503]],
  "gen8sketchmons": [["2022-05", 291], ["2022-04", 28146]],
  "gen8spikemuthcup": [["2023-01", 1], ["2022-11", 32237]],
  "gen8spookycup2021": [["2021-11", 21], ["2021-10", 30088]],
  "gen8staaabmons": [["2021-01", 101], ["2020-12", 68776]],
  "gen8stabmons": [["2022-11", 1225], ["2022-06", 4579]],
  "gen8stabmonsmixandmega": [["2021-09", 214], ["2021-08", 35555]],
  "gen8tagteamsingles": [["2022-11", 10], ["2022-10", 6431]],
  "gen8testyourluck": [["2022-01", 5839], ["2021-12", 11063]],
  "gen8thelosersgame": [["2021-04", 12], ["2021-03", 22674]],
  "gen8tiershift": [["2022-07", 171], ["2022-06", 41038]],
  "gen8tiershiftcamomonsobtainable": ["2021-06", 1],
  "gen8tinytourney": ["2021-12", 6791],
  "gen8trademarked": [["2022-03", 69], ["2022-02", 22103]],
  "gen8tundratourney": ["2020-11", 11496],
  "gen8ubers": [["2023-05", 1], ["2023-02", 14403]],
  "gen8ultimatefinale": [["2022-11", 32], ["2022-10", 3645]],
  "gen8uu": [["2023-08", 1], ["2022-11", 71767]],
  "gen8uususpecttest": ["2021-04", 332],
  "gen8vgc2020": [["2023-05", 1], ["2020-10", 417645]],
  "gen8vgc2021": [["2021-05", 3740], ["2021-04", 696293]],
  "gen8vgc2021series10": [["2021-11", 953], ["2021-10", 489659]],
  "gen8vgc2021series11": [["2022-02", 1018], ["2022-01", 136323]],
  "gen8vgc2021series9": [["2021-08", 530], ["2021-07", 211948]],
  "gen8vgc2021series9limitonerestrictedrestrictedlegendary": [
    ["2021-06", 2],
    ["2021-05", 3]
  ],
  "gen8vgc2022": [["2023-01", 1827], ["2022-12", 23336]],
  "gen8viabilities": [["2021-01", 5], ["2020-10", 248]],
  "gen8waterparadise": ["2021-07", 23412],
  "gen8zu": [["2023-04", 2], ["2022-10", 17108]],
  "gen91v1": ["2023-10", 115048],
  "gen92v2doubles": [["2023-10", 3556], ["2023-01", 11873]],
  "gen9350cup": [["2023-09", 4], ["2023-08", 29218]],
  "gen9almostanyability": ["2023-10", 49684],
  "gen9alphabetcup": [["2023-07", 310], ["2023-06", 39729]],
  "gen9anythinggoes": ["2023-10", 308983],
  "gen9balancedhackmons": ["2023-10", 39391],
  "gen9battlestadiumdoubles": [["2022-12", 4151], ["2022-11", 413572]],
  "gen9battlestadiumsingles": [["2022-12", 1165], ["2022-11", 142491]],
  "gen9battlestadiumsinglesregulationc": [["2023-07", 246], ["2023-06", 42472]],
  "gen9battlestadiumsinglesregulationd": [["2023-10", 279], ["2023-09", 59482]],
  "gen9battlestadiumsinglesregulatione": ["2023-10", 132149],
  "gen9battlestadiumsinglesseries1": [["2023-02", 2413], ["2023-01", 256579]],
  "gen9battlestadiumsinglesseries2": [["2023-04", 4947], ["2023-03", 103080]],
  "gen9bonustype": [["2023-09", 21], ["2023-08", 29635]],
  "gen9brokencup": [["2023-05", 34], ["2023-04", 145541]],
  "gen9camomons": [["2023-03", 18], ["2023-02", 8064]],
  "gen9cap": [["2023-10", 2571], ["2023-08", 8558]],
  "gen9convergence": ["2023-10", 40245],
  "gen9crossevolution": [["2023-05", 1], ["2023-04", 34851]],
  "gen9doubleslc": [["2023-09", 52], ["2023-02", 1094]],
  "gen9doublesou": ["2023-10", 293858],
  "gen9doublesubers": ["2023-10", 50472],
  "gen9doublesuu": ["2023-10", 22133],
  "gen9forceofthefallen": [["2023-08", 23], ["2023-07", 36731]],
  "gen9fortemons": [["2023-05", 1], ["2023-03", 146507]],
  "gen9franticfusions": [["2023-10", 74], ["2023-09", 68601]],
  "gen9freedomcup": [["2023-07", 2677], ["2023-06", 45142]],
  "gen9fullpotential": [["2023-01", 37], ["2022-12", 10022]],
  "gen9godlygift": ["2023-10", 26599],
  "gen9inheritance": [["2023-10", 826], ["2023-07", 57832]],
  "gen9kitakamiprologue": ["2023-10", 50610],
  "gen9lc": ["2023-10", 34951],
  "gen9meowcup": ["2023-04", 2941],
  "gen9metronomebattle": ["2023-10", 58334],
  "gen9mixandmega": ["2023-10", 5374],
  "gen9mixandmegacup": [["2023-07", 48], ["2023-06", 12160]],
  "gen9monotype": ["2023-10", 185953],
  "gen9nationaldex": ["2023-10", 788332],
  "gen9nationaldexag": [["2023-05", 3], ["2023-02", 12946]],
  "gen9nationaldexbh": [["2023-08", 41], ["2023-07", 14853]],
  "gen9nationaldexdoubles": ["2023-10", 54816],
  "gen9nationaldexmonotype": ["2023-10", 85744],
  "gen9nationaldexubers": ["2023-10", 264450],
  "gen9nationaldexuu": ["2023-10", 27257],
  "gen9nfe": [["2023-09", 27], ["2023-01", 1344]],
  "gen9nu": ["2023-10", 53886],
  "gen9ou": ["2023-10", 1709112],
  "gen9oususpect": ["2023-04", 9904],
  "gen9paldeaprologue": ["2023-03", 70251],
  "gen9partnersincrime": [["2023-10", 1366], ["2023-01", 16457]],
  "gen9partnersincrimesuspect": ["2023-04", 99],
  "gen9pokebilities": [["2023-05", 2], ["2023-04", 72556]],
  "gen9pu": ["2023-10", 65196],
  "gen9ru": ["2023-10", 67803],
  "gen9sharedpower": [["2023-01", 200], ["2022-12", 35293]],
  "gen9sharingiscaring": ["2023-10", 7469],
  "gen9stabmons": [["2023-10", 8963], ["2023-09", 12909]],
  "gen9teradonation": [["2023-04", 3], ["2023-03", 3410]],
  "gen9thecardgame": [["2023-06", 1], ["2023-05", 3163]],
  "gen9tiershift": [["2023-06", 86], ["2023-05", 64960]],
  "gen9trademarked": [["2023-07", 64], ["2023-06", 33897]],
  "gen9trickmagic": ["2023-10", 13133],
  "gen9ubers": ["2023-10", 131539],
  "gen9uu": ["2023-10", 314568],
  "gen9vgc2023regulationc": [["2023-07", 1205], ["2023-06", 285451]],
  "gen9vgc2023regulationd": [["2023-10", 122], ["2023-09", 554050]],
  "gen9vgc2023regulatione": ["2023-10", 1149474],
  "gen9vgc2023regulationebo3": ["2023-10", 285793],
  "gen9vgc2023series1": [["2023-02", 3899], ["2023-01", 1384164]],
  "gen9vgc2023series2": ["2023-04", 21261],
  "gen9voltturnmayhem": [["2023-02", 59], ["2023-01", 12786]],
  "gen9zu": [["2023-10", 8304], ["2023-05", 15242]],
  "generationshowdown": ["2015-02", 4140],
  "giftsofthegods": ["2016-10", 74763],
  "godsandfollowers": [["2016-02", 107], ["2016-01", 83565]],
  "gottalent": [["2016-07", 34], ["2016-06", 13217]],
  "hackmons1v1": [["2015-10", 690], ["2015-09", 85409]],
  "hackmonscup": [["2016-12", 81], ["2016-11", 55810]],
  "hiddentype": ["2015-03", 4838],
  "higheststatmeta": [["2015-11", 5], ["2015-10", 3863]],
  "inheritance": [["2015-12", 51], ["2015-11", 21753]],
  "inversebattle": ["2016-11", 1236],
  "johtoclassic": [["2016-06", 39], ["2016-05", 103707]],
  "kantoclassic": ["2016-03", 25279],
  "lcextended": ["2015-12", 1974],
  "lcsuspecttest": ["2016-07", 38265],
  "lcuu": ["2016-11", 168],
  "linked": [["2015-07", 57], ["2015-06", 18397]],
  "megamons": [["2016-05", 191], ["2016-04", 51161]],
  "metagamiate": [["2016-04", 11], ["2016-03", 24955]],
  "monogen": [["2016-02", 53], ["2016-01", 27549]],
  "monsjustmons": [["2015-09", 9], ["2015-08", 3273]],
  "mrboneswildride": ["2015-04", 486],
  "natureswap": [["2016-09", 24], ["2016-08", 33033]],
  "noguardgalaxy": [["2015-11", 110], ["2015-10", 12373]],
  "nostatus": [["2015-09", 11], ["2015-08", 3239]],
  "nususpecttest": ["2016-07", 89732],
  "ounomega": [["2016-05", 347], ["2015-11", 56505]],
  "oususpecttest": ["2016-11", 103986],
  "pgllittlecup": ["2015-05", 21477],
  "pikachucup": ["2015-08", 28155],
  "primalbattle": ["2015-09", 6501],
  "proteanpalace": [["2015-08", 54], ["2015-07", 8121]],
  "pususpecttest": ["2016-12", 10318],
  "randomdoublesbattle": ["2016-11", 402503],
  "randomtriplesbattle": ["2016-11", 93697],
  "returnd": ["2016-10", 23099],
  "rususpecttest": ["2016-10", 37507],
  "sametypestealthrock": ["2015-11", 1225],
  "scrappyskirmish": ["2015-11", 7792],
  "seasonaldimensiondoom": [["2016-04", 98], ["2016-03", 36566]],
  "seasonalhanvshun": [["2015-03", 1403], ["2015-02", 8991]],
  "seasonalpolaropposites": [["2016-03", 43], ["2016-01", 25843]],
  "seasonalrainbowroad": [["2015-10", 69], ["2015-08", 12711]],
  "seasonalsleighshowdown": [["2015-01", 501], ["2014-12", 8292]],
  "seasonalspacetimefuntimes": [["2015-02", 1597], ["2015-01", 18346]],
  "seasonalspoopyparty": [["2015-11", 489], ["2015-10", 14057]],
  "seasonalstrikesback": [["2014-12", 1264], ["2014-11", 2687]],
  "seasonalsupersquadsmackdown": [["2015-12", 80], ["2015-11", 25015]],
  "seasonalsuperstaffbros": [["2015-05", 2380], ["2015-04", 28501]],
  "seasonalyouarenotprepared": [["2015-07", 35], ["2015-05", 4249]],
  "sinnohclassic": ["2016-07", 49283],
  "sketchmons": [["2016-12", 34], ["2015-09", 37934]],
  "smogondoubles": ["2015-03", 168942],
  "smogondoublessuspecttest": [["2015-04", 82], ["2014-12", 34536]],
  "smogondoublesubers": ["2015-03", 10558],
  "smogondoublesuu": [["2015-03", 1574], ["2015-02", 2123]],
  "smogontriples": [["2016-11", 9449], ["2016-10", 19464]],
  "spookycup": ["2015-10", 30194],
  "stabmons": [["2016-12", 33], ["2016-11", 28234]],
  "statswitch": [["2015-01", 37], ["2014-12", 15796]],
  "tiershift": [["2016-11", 644], ["2016-09", 1888]],
  "typereflector": [["2016-06", 14], ["2016-05", 29397]],
  "uberssuspecttest": ["2015-04", 184],
  "unovaclassic": ["2016-08", 12416],
  "unreleasedou": [["2016-04", 1], ["2016-03", 3119]],
  "uunoscald": ["2015-03", 9705],
  "uususpecttest": ["2016-10", 28683],
  "vgc2014": ["2014-12", 49294],
  "vgc2015": [["2017-06", 33], ["2016-11", 54650]],
  "voltturnmayhem": [["2016-03", 50], ["2016-02", 18591]]
}